import styled from 'styled-components'

import { Typography } from '../Typography'

export const StyledList = styled.ol`
  margin: 20px 0 0;
  padding: 0;
  width: 1220px;
  max-width: 100%;
  list-style: none;
`

export const StyledListItem = styled.li<{ $dragging?: boolean }>`
  background-color: ${({ theme, $dragging }) => ($dragging ? '#f5fbfd' : theme.colors.gray[0])};
  overflow: hidden;
  height: 72px;
  border: 1px solid ${({ theme }) => theme.colors.common.paperStroke};
  box-shadow: 0px 5px 15px rgba(80, 142, 161, 0.1);
  border-radius: 4px;
  margin-top: 5px;
  z-index: ${({ $dragging }) => ($dragging ? 5 : 1)};
  position: relative;

  &:hover {
    background-color: #f5fbfd;
    cursor: ${({ $dragging }) => ($dragging ? 'grabbing' : 'grab')};
  }
`

export const TabContainer = styled.div`
  max-height: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const DragHandle = styled.div`
  margin-left: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    width: 20px;
    fill: ${({ theme }) => theme.colors.common.inputBorder};
  }
`

export const Count = styled(Typography).attrs({
  size: '700-sm',
})`
  margin-left: 14px;
  margin-right: 20px;
`

export const Title = styled(Typography).attrs({
  size: '700-md',
})`
  flex-grow: 1;
  flex-shrink: 0;
`

export const Description = styled(Typography).attrs({
  size: '400-xs',
  italic: true,
})`
  padding-right: 20px;
  width: 780px;
  max-width: 780px;
  line-height: 16.34px;
`
